import { render, staticRenderFns } from "./page-10.vue?vue&type=template&id=14bc0b6a&scoped=true&"
import script from "./page-10.vue?vue&type=script&lang=js&"
export * from "./page-10.vue?vue&type=script&lang=js&"
import style0 from "./page-10.vue?vue&type=style&index=0&id=14bc0b6a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14bc0b6a",
  null
  
)

export default component.exports